import {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VCardText,
  VSpacer
} from 'vuetify/lib'

import createDialog from '~/components/ProgrammaticDialog'

export const Component = {
  name: 'ConfirmDialog',
  props: {
    cancel: {
      type: String,
      default: 'Cancel'
    },
    confirm: {
      type: String,
      default: 'Yes'
    },
    content: {
      type: String,
      default: ''
    },
    /** gives confirm button an error color */
    destructive: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Are you sure you want to continue?'
    }
  },
  mounted () {
    document.addEventListener('keydown', this.enterKeyShortcut)
  },
  destroyed () {
    document.removeEventListener('keydown', this.enterKeyShortcut)
  },
  methods: {
    enterKeyShortcut ($event) {
      if ($event.key !== 'Enter') return
      this.$emit('close', true)
    }
  },
  render (h) {
    return h(VCard, [
      this.title && this.content ? h(VCardTitle, { class: 'pl-4 pr-4 pt-4 pb-0' }, this.title) : null,
      h(VCardText, {
        class: 'text-body-1 pa-4 black--text',
        domProps: {
          innerHTML: this.content || this.title
        }
      }),
      h(VCardActions, [
        h(VSpacer),
        h(VBtn, {
          on: {
            click: () => this.$emit('close', false)
          },
          props: {
            color: 'grey darken-2',
            text: true
          }
        }, this.cancel),
        h(VBtn, {
          on: {
            click: () => this.$emit('close', true)
          },
          props: {
            color: this.destructive ? 'error' : 'primary',
            text: true
          }
        }, this.confirm)
      ])
    ])
  }
}

export default createDialog(Component)
